import { Button, TextBody, ButtonProps } from '@ally/metronome-ui';
import { Modal } from '../../molecules';
import styled from 'styled-components';
import { useState } from 'react';

const StyledButton = styled(Button)`
  ${({ theme: { colors } }): string => `
    color: ${colors['blue-800']};
  `}
`;

type IProps = {
  to: string;
  title?: string;
  modalBody?: React.FunctionComponentElement<any>;
} & Pick<ButtonProps, 'variant' | 'text'>;

const PdfModal: React.FC<IProps> = ({
  title = 'Heads Up',
  to,
  variant,
  text,
  modalBody,
}) => {
  const [open, setOpen] = useState(false);

  const handleRedirect = (url: string) => {
    setOpen(false);
    window.open(url, '_blank', 'noopener noreferrer');
  };

  const defaultModalBody = (
    <TextBody tag='p' size='sm'>
      <TextBody tag='span' weight='bold' size='sm'>
        You’re about to open a PDF that may have links to third-party sites Ally
        doesn’t own or control.
      </TextBody>
      <br /> <br />
      FYI: Those sites have their own privacy policies and levels of secuirty.
      We suggest reviewing those policies and any terms and conditions on those
      sites. Ready to go?
    </TextBody>
  );

  return (
    <Modal
      open={open}
      onOpenChange={setOpen}
      heading={title}
      headingProps={{ fontSize: '1.6rem', color: '#650360' }}
      content={modalBody ?? defaultModalBody}
      continue={() => handleRedirect(to)}
      cancel={() => setOpen(false)}
      trigger={
        <StyledButton
          variant={variant}
          text={text ?? ''}
          onClick={() => setOpen(true)}
        />
      }
      width='md'
    />
  );
};

export default PdfModal;
